import api, { apiError } from "@/lib/api";

export const base = (cid) => `/superadmin/service-clients/${cid}/imports`;

export const migApi = {
  types: (cid) => api.get(`${base(cid)}/types`).then((r) => r.data),
  list: (cid) => api.get(base(cid)).then((r) => r.data),
  get: (cid, bid) => api.get(`${base(cid)}/${bid}`).then((r) => r.data),
  upload: (cid, form) => api.post(base(cid), form, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data),
  mapping: (cid, bid, body) => api.put(`${base(cid)}/${bid}/mapping`, body).then((r) => r.data),
  validate: (cid, bid) => api.post(`${base(cid)}/${bid}/validate`).then((r) => r.data),
  commit: (cid, bid, body) => api.post(`${base(cid)}/${bid}/commit`, body).then((r) => r.data),
  migration: (cid, bid, body) => api.put(`${base(cid)}/${bid}/migration`, body).then((r) => r.data),
  eligibility: (cid, bid) => api.get(`${base(cid)}/${bid}/rollback-eligibility`).then((r) => r.data),
  rollback: (cid, bid) => api.post(`${base(cid)}/${bid}/rollback`).then((r) => r.data),
  remove: (cid, bid) => api.delete(`${base(cid)}/${bid}`).then((r) => r.data),
  downloadCsv: async (cid, bid, filename) => {
    const { data } = await api.get(`${base(cid)}/${bid}/errors.csv`, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a"); a.href = url; a.download = filename || `import-review-${bid.slice(0, 8)}.csv`; a.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  },
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (d?.service_unavailable || e?.response?.status === 503) return "NEEC Service migration service unavailable. Try again or refresh.";
  if (!e?.response) return "NEEC Service migration service unavailable. Try again or refresh.";
  const m = apiError(d);
  return Array.isArray(d?.reasons) && d.reasons.length ? `${m} ${d.reasons.join(" ")}` : m;
};

export const isUnavailable = (e) => !e?.response || e.response.status === 503;

export const STATUS_STYLE = {
  uploaded: "bg-sky-500/15 text-sky-700", mapped: "bg-indigo-500/15 text-indigo-700", validated: "bg-amber-500/15 text-amber-700",
  committed: "bg-emerald-500/15 text-emerald-700", rolled_back: "bg-zinc-500/15 text-zinc-600", failed: "bg-rose-500/15 text-rose-700",
};
export const ROW_STYLE = { ready: "text-emerald-700 bg-emerald-500/10", warning: "text-amber-700 bg-amber-500/10", error: "text-rose-700 bg-rose-500/10", duplicate: "text-violet-700 bg-violet-500/10", skipped: "text-zinc-600 bg-zinc-500/10" };
export const label = (s) => (s || "").replace(/_/g, " ");
export const fmtDate = (d) => (d ? new Date(d).toLocaleString() : "-");
export const stepForStatus = (s) => ({ uploaded: 1, mapped: 2, validated: 3, committed: 5, rolled_back: 5, failed: 5 }[s] ?? 0);
export const MIGRATION_TYPE_LABEL = { self_service: "Self service", neec_assisted: "NEEC Assisted", historical: "Historical" };
